import { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
export default function DownloadReport() {
  const [type, setType] = useState('expense');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const { t } = useTranslation();

  const handleDownload = async () => {
    try {
      const token = localStorage.getItem('token'); // or from context if you're using auth
      const response = await axios.get(
        `https://trakersmallbusienss-3.onrender.com/api/auth/report/pdf?type=${type}&start=${start}&end=${end}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob', // IMPORTANT: This tells axios to expect binary
        }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${type}-report.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading PDF:', error);
      alert('Failed to download report.');
    }
  };

  return (
    <div className="p-4 bg-white rounded shadow w-full max-w-md mx-auto">
  <h2 className="text-xl font-bold mb-4">{t('downloadReportCard.title')}</h2>

  <label className="block mb-2">
    {t('downloadReportCard.typeLabel')}
    <select
      value={type}
      onChange={(e) => setType(e.target.value)}
      className="border p-2 w-full"
    >
      <option value="expense">{t('downloadReportCard.typeOptions.expense')}</option>
      <option value="income">{t('downloadReportCard.typeOptions.income')}</option>
    </select>
  </label>

  <label className="block mb-2">
    {t('downloadReportCard.startDate')}
    <input
      type="date"
      value={start}
      onChange={(e) => setStart(e.target.value)}
      className="border p-2 w-full"
    />
  </label>

  <label className="block mb-2">
    {t('downloadReportCard.endDate')}
    <input
      type="date"
      value={end}
      onChange={(e) => setEnd(e.target.value)}
      className="border p-2 w-full"
    />
  </label>

  <button
    onClick={handleDownload}
    className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
  >
    {t('downloadReportCard.downloadButton')}
  </button>
</div>
  );
}
